import { Typography, Button } from "../../components"
import "./styles.css";

export default function RoutekaartKetenpartners(props) {
    return (
        <div className="container">
            <iframe
                title="Routekaart NOLIA BabyFeeding voor ketenpartners"
                src="https://app.enormail.eu/subscribe/51753ddca90b4628e24a1950497c8ca4"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}